export default [
  {
    path: '/faceRecognition1',
    component: () => import('@/views/FaceRecognition1'),
    meta: { requireAuth: true }
  }
]
